import { createAsyncApi } from "@app/state/partials/async"
import { createToast } from "@/modules/toast-message"


export default function createFACTypeMembershipData(){
    const api = createAsyncApi(
        'bt_get_fac_type_membership',
        'GET',
        {
            responseKey : 'fac_type_membership',
            parameters  : {
                fac_type_membership: {},
            },
            callbacks: {
                onError: (data, original, errors) => {
                    if(data.code === 404){
                        createToast("This membership couldn't be found", "error")
                        errors.value.display_error = ['Membership doesn\'t exist']
                    } else {
                        createToast("Couldn't load membership, please try again", "error")
                        errors.value.display_error = ['Membership failed to load, please try again']
                    }
                }
            }
        }
    )

    return {
        ...api,
    }
}